(() => {
  if (window.trucastFreeKitBound) return;
  window.trucastFreeKitBound = true;
  const root = window.Shopify?.routes?.root || '/';
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const gift = form.querySelector('[data-tc-gift]');
    if (!gift) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const status = gift.querySelector('[role="status"]');
    const choice = gift.querySelector('input[name="tc_gift_choice"]:checked');
    status.hidden = false;
    if (!choice) { status.textContent = gift.dataset.choose; return; }
    if (gift.dataset.preview === 'true') {
      status.textContent = gift.dataset.previewMessage;
      return;
    }
    if (form.dataset.tcGiftBusy === 'true') return;
    const data = new FormData(form);
    const gameId = Number(data.get('id'));
    const quantity = Number(data.get('quantity') || 1);
    if (!Number.isSafeInteger(gameId) || !Number.isSafeInteger(quantity) || quantity < 1) {
      status.textContent = gift.dataset.error;
      return;
    }
    const game = {id:gameId,quantity};
    const properties = {};
    for (const [key,value] of data.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && typeof value === 'string') properties[match[1]] = value;
    }
    if (Object.keys(properties).length) game.properties = properties;
    if (data.get('selling_plan')) game.selling_plan = data.get('selling_plan');
    const items = [game];
    if (choice.value !== 'none') items.push({id:Number(choice.value),quantity});
    form.dataset.tcGiftBusy = 'true';
    const buttons = [...form.querySelectorAll('[type="submit"]')];
    const disabledStates = buttons.map(button => button.disabled);
    buttons.forEach(button => {button.disabled = true;});
    status.hidden = true;
    try {
      const response = await fetch(root+'cart/add.js', {
        method:'POST',credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items})
      });
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error('add');
      window.location.assign(root+'cart');
    } catch {
      status.hidden = false;
      status.textContent = gift.dataset.error;
    } finally {
      delete form.dataset.tcGiftBusy;
      buttons.forEach((button,index) => {button.disabled = disabledStates[index];});
    }
  }, true);
})();
